import { Routes } from '@angular/router';

import { MpsIsAdminGuard } from '../mps/guards/mps-isadmin.guard';
import { MpsLoggedInGuard } from '../mps/guards/mps-loggedin.guard';
import { applicationRouteNames } from './application-route-names';
import { AdminOrManagerEoGuard } from './guards/admin-or-manager-eo.guard';
import { MpsIsAdminOrManagerEoGuard } from './guards/mps-is-admin-or-manager-eo.guard';
import { MpsIsManagerOrAboveGuard } from './guards/mps-is-manager-or-above.guard';

export const applicationRoutes: Routes = [
  {
    path: '',
    redirectTo: applicationRouteNames.dashboard,
    pathMatch: 'full',
  },
  {
    path: applicationRouteNames.dashboard,
    loadComponent: () => import('./dashboard/dashboard.component').then((m) => m.DashboardComponent),
    data: { title: 'general.navigation.dashboard' },
    canActivate: [MpsLoggedInGuard],
    canLoad: [],
  },
  {
    path: applicationRouteNames.workflows,
    loadComponent: () => import('./workflows/workflows.component').then((m) => m.WorkflowsComponent),
    data: { title: 'general.navigation.workflows' },
    canActivate: [MpsIsManagerOrAboveGuard],
    canLoad: [MpsIsManagerOrAboveGuard],
  },
  {
    path: applicationRouteNames.administration,
    data: { title: 'general.navigation.administration' },
    canActivate: [MpsIsManagerOrAboveGuard, AdminOrManagerEoGuard],
    canLoad: [AdminOrManagerEoGuard],
    children: [
      {
        path: applicationRouteNames.users,
        loadComponent: () => import('./administration/users/list/list.component').then((m) => m.ListComponent),
        data: { title: null },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.lokalise,
        loadComponent: () => import('./administration/lokalise/lokalise.component').then((m) => m.LokaliseComponent),
        data: { title: 'general.navigation.lokalise' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.orgEntities,
        loadComponent: () =>
          import('./administration/org-entities/org-entities.component').then((m) => m.OrgEntitiesComponent),
        data: { title: 'general.navigation.org_entities' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
      {
        path: applicationRouteNames.users + '/' + applicationRouteNames.usersRoles,
        loadComponent: () =>
          import('./administration/users/role-management/role-management.component').then(
            (m) => m.RoleManagementComponent
          ),
        data: { title: 'general.navigation.users_roles' },
        canActivate: [MpsIsAdminOrManagerEoGuard],
        canLoad: [MpsIsAdminOrManagerEoGuard],
      },
      {
        path: applicationRouteNames.sync,
        loadComponent: () => import('./administration/sync/sync.component').then((m) => m.SyncComponent),
        data: { title: 'administration.sync_management.title' },
        canActivate: [MpsIsAdminGuard],
        canLoad: [MpsIsAdminGuard],
      },
    ],
  },
];
